/**
 * ROWIE — PDP BNPL panel
 *
 * Same open/close mechanics as rowie-pdp-shop-the-look.js, including the
 * portal to <body>: the panel is position:fixed but an ancestor of the
 * product content column establishes a stacking context, which would trap
 * it below the gallery. State lives on <body>, not on the root, because
 * the panel is no longer a descendant of it.
 */

(function () {
  const SELECTORS = {
    root: '[data-rowie-bnpl]',
    trigger: '[data-bnpl-open]',
    panel: '[data-bnpl-panel]',
    overlay: '[data-bnpl-overlay]',
    close: '[data-bnpl-close]',
  };

  class PdpBnpl {
    constructor(root) {
      this.root = root;
      this.trigger = root.querySelector(SELECTORS.trigger);
      this.panel = root.querySelector(SELECTORS.panel);
      this.overlay = root.querySelector(SELECTORS.overlay);
      this.closeBtn = root.querySelector(SELECTORS.close);

      if (!this.panel || !this.trigger) return;

      this.init();
    }

    init() {
      this.movePanelToBody();
      this.bindOpenClose();
      this.bindEscape();
    }

    movePanelToBody() {
      if (this.overlay && this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }
      if (this.panel && this.panel.parentElement !== document.body) {
        document.body.appendChild(this.panel);
      }
    }

    bindOpenClose() {
      this.trigger.addEventListener('click', () => {
        if (document.body.classList.contains('rowie-bnpl-open')) this.close();
        else this.open();
      });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
    }

    open() {
      document.body.classList.add('rowie-bnpl-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    close() {
      document.body.classList.remove('rowie-bnpl-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        if (!document.body.classList.contains('rowie-bnpl-open')) {
          document.body.style.overflow = '';
        }
      }, 400);
    }

    bindEscape() {
      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('rowie-bnpl-open')) {
          this.close();
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.root).forEach((root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      new PdpBnpl(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(SELECTORS.root).forEach((root) => {
      root.removeAttribute('data-initialised');
    });
    initAll();
  });
})();